import { UPDATE_IDEA, DEL_IDEA, GET_IDEA } from '../constants';

export default (state=[],action) => {
    let ideas=[];
    switch(action.type){
        case GET_IDEA:
        return {
            ideas: action.ideas,
            result: action.result
        };
        

        case UPDATE_IDEA:
        ideas=state.ideas.map(idea=>{
            idea.idea = (idea.id===action.idea.id) ? action.idea.idea : idea.idea
            return idea;
        })
        return {
            ideas,
            result: action.result  
        };

        case DEL_IDEA:
        ideas=state.ideas.filter(idea=>idea.id!==action.id)
        return {
            ideas,
            result: action.result
        };

        default:
        return {state};
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ideaReducer.js